import { useCallback, useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-enterprise";
import {
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  MenuItem,
  InputLabel,
  DialogContent,
  DialogTitle,
  Dialog,
  styled,
  Checkbox,
  DialogActions,
  Tooltip,
  Menu,
} from "@mui/material";
import { Row, Col, Form } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InfoIcon from "@mui/icons-material/Info";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CloseIcon from "@mui/icons-material/Close";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import HistoryIcon from "@mui/icons-material/History";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { DialogProps } from "../../types/SimpleSearchModel";
import {
  downloadFile,
  multipleDownloadFile,
} from "../../api/simpleSearchApi/simpleSearchApi";
import styles from "./AdvancedSearch.module.css";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import "../../config/colors.css";
import ConfirmationDialog from "../SimpleSearch/ConfirmationDialog";
import InfoDrawer from "../SimpleSearch/InfoDrawer";
import { ListFieldModel } from "../../types/ListFieldModel";
import {
  getCompareMetaData,
  getFieldData,
  getFileDownload,
} from "../../api/listSearchAPI/listSearchApi";
import {
  AdvanceDocumentViewObj,
  CompareMetaDataRequestModel,
  FileDownloadRequestModel,
} from "../../types/ListSearchModel";
import { UserModel } from "../../types/userDataModel";
import { useLoader } from "../../context/LoaderContext";
import {
  QueryModel,
  SaveQueryModel,
  SearchCriteriaDetailsModel,
  UpdateQueryModel,
} from "../../types/AdvanceSearchModel";
import {
  getAdvanceSearchData,
  GetSavedQuery,
  GetSavedQueryDetails,
  SaveAdvanceSearchQuer,
} from "../../api/advanceSearchApi/advanceSearchApi";
import AssetHistory from "../Alert/AssetHistory";
import { DownstreamreprocessModel } from "../../types/DownstreamreprocessModel";
import { GetARFDocuments } from "../../api/downstreamSummaryApi/downstreamSummaryApi";
import { ARFDocument } from "../../types/ARFDocumentModel";
import { useSnackbar } from "../Common/SnackbarContext";
import { appSettings } from "../../config/appSetting";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";
import { urlConfig } from "../../config/urlConfig";
import DownstreamFDReprocesspopup from "../Alert/DownstreamFDReprocesspopup";
import ConfirmationAlert from "../Alert/ConfirmationAlert";
import DownstreamSubSystemReprocessPopup from "../Alert/DownstreamSubSystemReprocessPopup";

import { FormatDate } from "../Common/CommonMethods";
import FileUploads from "../Alert/FileUploads";
import AddNotes from "../Alert/AddNotes";
import RenamePopup from "../Alert/Rename";
import RejectFile from "../Alert/RejectFile";
import MoveToPreflightPopup from "../Alert/MoveToPreflightPopup";
import MoveToFinal from "../Alert/MoveToFinal";
import ReprocessSendToPreflight from "../Alert/ReprocessSendToPreflight";
import isPagePermission from "../../utils/common";
import LocalStorageUtil from "../../utils/localStorage";
import ExcelIcon from "../../assets/images/ExcelExport.png";
import moment from "moment";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface Option {
  value: number;
  label: string;
}

interface Category {
  label: string;
  options: Option[];
}

const AdvancedSearch = () => {
  const { showSnackbar } = useSnackbar();
  const { setLoading } = useLoader();
  const [txtSearch, setTxtSearch] = useState("");
  const [zipDownload, setZipDownload] = useState(false);
  const [deleteRightShow, setDeleteRightShow] = useState(false);
  const [gridApi, setGridApi] = useState<any>();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [onSearchClick, setOnSearchClick] = useState(false);
  const [loggedUserData, setLoggedUserData] = useState<UserModel | null>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };
  const selectedFieldValueRef = useRef<string | null>(null);
  const selectedFieldTextRef = useRef<string | null>(null);
  const selectedCategoryNameRef = useRef<string | null | undefined>(null);
  const selectedOperatorValueRef = useRef<string | null>(null);
  const [dialogOpenState, setDialogOpenState] = useState(false);
  const [fields, setFields] = useState<{ key: string; value: string }[]>([]);
  const [thumbnail, setthumbnail] = useState<{ key: string; value: string }[]>(
    []
  );
  const [categories, setCategories] = useState<Category[]>([]);
  const [_IsAccountDAOEnabled, set_IsAccountDAOEnabled] =
    useState<boolean>(true);
  const [_IsAccountDSAEnabled, set_IsAccountDSAEnabled] =
    useState<boolean>(false);
  const [_IsAccountEdeliveryEnabled, set_IsAccountEdeliveryEnabled] =
    useState<boolean>(true);
  const [activeButton, setActiveButton] = useState<string>("Build Query");
  const [selectQuery, setSelectQuery] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState<boolean>(true);
  const [index] = useState<number>(0);
  const [QueueType, setQueueType] = useState<number>(2);
  const [inputGroups, setInputGroups] = useState<any[]>([
    {
      selectedField: "",
      selectedFieldText: "",
      selectedOperator: "",
      inputValue: "",
      selectedCategory: "",
      selectedLogicalOperator: "",
      isDateField: false,
      dateValue: "",
      isDateTimeField: false,
      isBetweenOperator: false,
      inputValue2: "",
    },
  ]);
  const [errors, setErrors] = useState<any[]>([]);
  const [isSaveQueryOpen, setIsSaveQueryOpen] = useState(false);
  const [assetHistoryOpen, setAssetHistoryOpen] = useState(false);
  const [assetHistoryData, setAssetHistoryData] = useState<any>(null);
  const [txtQueryName, setTxtQueryName] = useState<string>("");
  const selectedInputGroupsRef = useRef<any[]>([]);
  const [rowData, setRowData] = useState<any[]>([]);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);
  const [gridRecordExist, setGridRecordExist] = useState(false);
  const [SaveQuery, setSaveQuery] = useState<any[]>([]);
  const [selectedQueryValue, setSelectedQueryValue] =
    useState<string>("Select");
  const [selectedQueryText, setSelectedQueryText] = useState<string>("Select");
  const [showLoader, setShowLoader] = useState(false);
  //#region Context Menu
  const [deleteConfirmationDialogOpen, setdeleteConfirmationDialogOpen] =
    useState(false);
  const [deleteDocumentData, setDeleteDocumentData] = useState<any>(null);
  const [isArfMessage, setIsArfMessage] = useState(false);
  const [reprocessSubSystemOpen, setReprocessSubSystemOpen] = useState(false);
  const [reprocessSubSystemOpenData, setReprocessSubSystemOpenData] =
    useState<any>(null);
  const [reprocessFDOpen, setReprocessFDOpen] = useState(false);
  const [reprocessFDOpenData, setReprocessFDOpenData] = useState<any>(null);
  const [reprocessEDeliveryOpen, setReprocessEDeliveryOpen] = useState(false);
  const [reprocessEDeliveryOpenData, setReprocessEDeliveryOpenData] =
    useState<any>(null);
  const [updateQueryCreatedBy, setUpdateQueryCreatedBy] = useState<number>(0);
  const [isPublic, setIsPublic] = useState(true);
  const [uploadFilesOpen, setUploadFilesOpen] = useState(false);
  const [uploadFilesData, setUploadFilesData] = useState<any>(null);
  const [addNotesOpen, setAddNotesOpen] = useState(false);
  const [addNotesData, setAddNotesData] = useState(false);
  const [renamePopupOpen, setRenamePopupOpen] = useState(false);
  const [renameData, setRenameData] = useState<any>(null);
  const [rejectPopupOpen, setRejectPopupOpen] = useState(false);
  const [rejectData, setRejectData] = useState<any>(null);
  const [moveToPreflightOpen, setMoveToPreflightOpen] = useState(false);
  const [moveToPreflightData, setMoveToPreflightData] = useState<any>(null);
  const [moveToFinalFolderOpen, setMoveToFinalFolderOpen] = useState(false);
  const [moveToFinalFolderData, setMoveToFinalFolderData] = useState<any>(null);
  const [moveToFinalPopupTitle, setMoveToFinalPopupTitle] =
    useState<string>("");
  const [reprocessSendToPreflightOpen, setReprocessSendToPreflightOpen] =
    useState(false);
  const [reprocessSendToPreflightData] = useState<any>(null);
  const [documentStatusValue] = useState<number>(0);
  const [contextMenuType, setContextMenuType] = useState<number>(1);
  const [gridHeight, setGridHeight] = useState<number>(
    window.innerHeight * 0.7
  ); // Default to 70% of screen

  useEffect(() => {
    const handleResize = () => {
      setGridHeight(window.innerHeight * 0.7);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const operator = [
    {
      value: "Equals",
      label: "Exactly Matches =",
    },
    {
      value: "NotEqualString",
      label: "Does Not Contain",
    },
    {
      value: "StartsWith",
      label: "Begins with",
    },
    {
      value: "EndsWith",
      label: "Ends with",
    },
    {
      value: "Contains",
      label: "Contains",
    },
    {
      value: "IN",
      label: "IN",
    },
  ];

  const dateOperator = [
    {
      value: "Equals",
      label: "Exactly Matches =",
    },
    {
      value: "GreaterThan",
      label: "Greater than >",
    },
    {
      value: "GreaterThanOrEqual",
      label: "Greater or equal >=",
    },
    {
      value: "LessThan",
      label: "Less than <",
    },
    {
      value: "LessThanOrEqual",
      label: "Less or equal <=",
    },
    {
      value: "NotEqual",
      label: "Not equal <>",
    },
    {
      value: "Between",
      label: "Between",
    },
  ];

  const andOr = [
    {
      value: "AND",
      label: "AND",
    },
    {
      value: "OR",
      label: "OR",
    },
  ];
  const [validateSaveQuery, setValidateSaveQuery] = useState<boolean>(false);
  const handleSaveQuerySubmit = () => {
    if (errorValidate()) {
      return;
    }
    setValidateSaveQuery(false);
    setIsSaveQueryOpen(true);
    setTxtQueryName("");
  };

  //Handel delete context menu option
  const handelDeleteContextMenuOption = async (rowsData: any) => {
    setLoading(true);
    if (!gridRef.current) return;

    let selectedRows = gridRef.current.api.getSelectedRows();
    selectedRows = selectedRows.length > 0 ? selectedRows : rowsData;

    // Helper to build ARFDocument array from rows
    const buildArfDocuments = (rows: any[]): ARFDocument[] =>
      rows.map((row) => ({
        ProjectDocumentIds: row["Document ID"],
        ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
        AccountId: Number(LocalStorageUtil.getItem("accountId")),
        DocumentStreamId: row["DocumentStreamID"],
        UserId: Number(LocalStorageUtil.getItem("userId")),
      }));

    // Normalize selectedRows to array
    let rowsArray: any[];
    if (Array.isArray(selectedRows)) {
      rowsArray = selectedRows;
    } else if (selectedRows) {
      rowsArray = [selectedRows];
    } else {
      rowsArray = [];
    }

    if (rowsArray.length === 0) {
      console.log("No document selected to delete");
      return;
    }

    const actionCode =
      (rowsArray[0] as Record<string, any>)["ACTION CODE"]?.toLowerCase?.() ??
      (selectedRows as Record<string, any>)["ACTION CODE"];

    // If actionCode is not 'arf', proceed with ARF logic
    if (actionCode !== "arf") {
      const arfDocuments = buildArfDocuments(rowsArray);
      if (arfDocuments.length > 0) {
        const arfDocumentResponse = await GetARFDocuments(arfDocuments);
        setDeleteDocumentData(arfDocuments);
        setdeleteConfirmationDialogOpen(true);
        setIsArfMessage(arfDocumentResponse === true);
      }
      return;
    }

    // If actionCode is 'arf', handle single/multiple selection
    const arfDocuments = buildArfDocuments(rowsArray);
    if (arfDocuments.length > 0) {
      setDeleteDocumentData(arfDocuments);
      setdeleteConfirmationDialogOpen(true);
      setIsArfMessage(false);
    }
  };

  //Handel reprocess to source
  const handleReprocessTosource = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: undefined,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID:
            rowsData.SubSystemConfigurationId.toString() ?? "",
          ParentDocumentStreamID: rowsData.ParentDocumentStreamID.toString(),
          SubSystemName: rowsData.SubSystemName.toString(),
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: undefined,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID:
              rowsData.SubSystemConfigurationId.toString() ?? "",
            ParentDocumentStreamID: rowData.ParentDocumentStreamID.toString(),
            SubSystemName: rowData.SubSystemName.toString(),
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessSubSystemOpenData(downstreamrReprocessModel);
        setReprocessSubSystemOpen(true);
      } else {
        showSnackbar("No document selected to reprocess", true);
      }
    }
  };

  //Handel send to preflight and send to downsample
  const handleSendToPreflight_SendToDownSample = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: undefined,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID: undefined,
          ParentDocumentStreamID: undefined,
          SubSystemName: undefined,
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: undefined,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID: undefined,
            ParentDocumentStreamID: undefined,
            SubSystemName: undefined,
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessFDOpenData(downstreamrReprocessModel);
        setReprocessFDOpen(true);
      } else {
        showSnackbar("No FD document selected to reprocess", true);
      }
    }
  };

  //Handel send to e-delivery
  const handleSendToEDelivery = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: undefined,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID: undefined,
          ParentDocumentStreamID: undefined,
          SubSystemName: undefined,
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: undefined,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID: undefined,
            ParentDocumentStreamID: undefined,
            SubSystemName: undefined,
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessEDeliveryOpenData(downstreamrReprocessModel);
        setReprocessEDeliveryOpen(true);
      } else {
        showSnackbar("No FD document selected to reprocess", true);
      }
    }
  };

  const handleAddInputGroup = () => {
    setInputGroups([
      ...inputGroups,
      {
        selectedField: "",
        selectedFieldText: "",
        selectedOperator: "",
        inputValue: "",
        selectedCategory: "",
        selectedLogicalOperator: "",
        isDateField: false,
        dateValue: "",
        isDateTimeField: false,
        isBetweenOperator: false,
        inputValue2: "",
      },
    ]);
  };

  const handleDeleteInputGroup = (index: number) => {
    const newInputGroups = inputGroups.filter((_, i) => i !== index);
    if (handleDeleteInputGroup.length > 2) {
      // DEAD CODE
      newInputGroups[index].selectedField = "";
      newInputGroups[index].selectedOperator = "";
      newInputGroups[index].inputValue = "";
    }

    setInputGroups(newInputGroups);
  };

  const handleFieldChange = (
    index: number,
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const newField = event.target.value;
    const selectedText = event.target.options[event.target.selectedIndex].text;
    const optgroupElement =
      event.target.options[event.target.selectedIndex].parentElement;
    const selectedCategoryName = optgroupElement
      ? (optgroupElement as HTMLOptGroupElement).label
      : null;

    selectedFieldValueRef.current = newField;
    selectedFieldTextRef.current = selectedText;
    selectedCategoryNameRef.current = selectedCategoryName;

    const newInputGroups = [...inputGroups];
    newInputGroups[index].dateValue = "";
    newInputGroups[index].inputValue2 = "";
    newInputGroups[index].inputValue = "";
    newInputGroups[index].selectedOperator = "";
    newInputGroups[index].isBetweenOperator = false;
    newInputGroups[index].selectedField = event.target.value;
    newInputGroups[index].selectedFieldText = selectedText;
    newInputGroups[index].selectedCategory = selectedCategoryName;
    if (selectedText.includes("Date")) {
      newInputGroups[index].isDateField = true;
    } else {
      newInputGroups[index].isDateField = false;
    }
    if (selectedText.includes("Time")) {
      newInputGroups[index].isDateTimeField = true;
    } else {
      newInputGroups[index].isDateTimeField = false;
    }
    setInputGroups(newInputGroups);
  };

  const handleLogicalOperatorChange = (
    index: number,
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const newInputGroups = [...inputGroups];
    newInputGroups[index].selectedLogicalOperator = event.target.value;
    setInputGroups(newInputGroups);
    const newField = event.target.value;

    selectedOperatorValueRef.current = newField;
  };

  const handleOperatorChange = (
    index: number,
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const newInputGroups = [...inputGroups];
    newInputGroups[index].selectedOperator = event.target.value;
    newInputGroups[index].inputValue = "";
    newInputGroups[index].dateValue = "";
    newInputGroups[index].inputValue2 = "";
    if (event.target.value === "Between") {
      newInputGroups[index].isBetweenOperator = true;
    } else {
      newInputGroups[index].isBetweenOperator = false;
    }
    setInputGroups(newInputGroups);
    const newField = event.target.value;

    selectedOperatorValueRef.current = newField;
  };

  const [dialogProps, setDialogProps] = useState<DialogProps>({
    dialogTitle: "",
    contentText: "",
    confirmText: "",
    closeText: "",
    onConfirm: null,
  });

  const txtSearchRef = useRef(txtSearch);
  const isSearchClicked = useRef(onSearchClick);
  const gridRef = useRef<AgGridReact>(null);

  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = appSettings.agGridDefaulPageSize;

  useEffect(() => {
    txtSearchRef.current = txtSearch;
    isSearchClicked.current = onSearchClick;
    selectedInputGroupsRef.current.push([...inputGroups]);
  }, [txtSearch, onSearchClick, inputGroups]);

  useEffect(() => {
    getField();
    getLoogedUserData();
  }, []);

  const getField = async () => {
    setLoading(true);
    const params: ListFieldModel = {
      accountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
    };
    try {
      const response = await getFieldData(params);
      const transformedData = transformData(response);
      setCategories(transformedData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const transformData = (data: any[]): Category[] => {
    const categoryMap: { [key: string]: Category } = {};

    data.forEach((item) => {
      const { categoryName, fieldMappingId, field } = item;

      if (!categoryMap[categoryName]) {
        categoryMap[categoryName] = {
          label: categoryName,
          options: [],
        };
      }

      categoryMap[categoryName].options.push({
        value: fieldMappingId,
        label: field,
      });
    });
    return Object.values(categoryMap);
  };

  // Helper function to get action handler mapping
  const getActionHandler = (
    actionType: number
  ): ((rowData: any) => void) | null => {
    const actionMap: Record<number, (rowData: any) => void> = {
      0: handelDeleteContextMenuOption,
      1: handleReprocessTosource,
      2: handleSendToPreflight_SendToDownSample,
      3: handleSendToPreflight_SendToDownSample,
      4: handleSendToEDelivery,
      5: (rowData) => handelUploadFiles(rowData, 1),
      6: handleAddNotes,
      7: (rowData) => moveToPreflight(rowData, 0),
      9: (rowData) => moveToFinalFolder(rowData, 0, 2),
      10: (rowData) => moveToFinalFolder(rowData, 0, 3),
      11: (rowData) => moveToFinalFolder(rowData, 0, 1),
      12: (rowData) => moveToFinalFolder(rowData, 0, 1),
      14: handleRename,
      15: handleReject,
    };

    return actionMap[actionType] || null;
  };

  // Helper function to get excluded statuses for upload/rename
  const getExcludedUploadStatuses = (): number[] => {
    return [
      6, 20, 21, 11, 17, 18, 3, 23, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 35,
    ];
  };

  // Helper function to get excluded statuses for reject
  const getExcludedRejectStatuses = (): number[] => {
    return [6, 20, 23, 24, 11, 27, 17, 18, 28, 30, 31, 32, 33, 34, 35];
  };

  // Helper function to check if status is excluded
  const isStatusExcluded = (
    status: number,
    excludedStatuses: number[]
  ): boolean => {
    return excludedStatuses.includes(status);
  };

  // Helper function to render action buttons
  const renderActionButtons = (rowData: any) => {
    return (
      <>
        {isPagePermission("Allow Download", "AdvanceSearch", 4) && (
          <Tooltip title="Click here to download the document(s)">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => fileDownload(rowData)}
            >
              <FileDownloadIcon />
            </IconButton>
          </Tooltip>
        )}
        {isPagePermission("Allow DocumentPreView", "AdvanceSearch", 7) && (
          <Tooltip title="Click to view">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => viewDocument(rowData)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        )}
        {isPagePermission("Allow Metadata Information", "AdvanceSearch", 8) && (
          <Tooltip title="Click to view the file information and history">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => infoDocument(rowData)}
            >
              <InfoIcon />
            </IconButton>
          </Tooltip>
        )}
        {isPagePermission("Allow Version History", "AdvanceSearch") && (
          <Tooltip title="Click to view Asset History">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => viewHistory(rowData)}
            >
              <HistoryIcon />
            </IconButton>
          </Tooltip>
        )}
      </>
    );
  };

  // Helper function to check reprocess to source conditions
  const shouldShowReprocessToSource = (params: any): boolean => {
    return (
      params.data.IsAllowSubSystemReprocess === "True" &&
      params.data["ACTION CODE"] !== "ARF" &&
      isPagePermission("", "", 1445) &&
      LocalStorageUtil.getItem("contextName") !== "DocDistro_MOAForms"
    );
  };

  // Helper function to check send to preflight conditions
  const shouldShowSendToPreflight = (rowData: any): boolean => {
    return (
      rowData.Rendition_Intern?.toUpperCase() ===
        "CURRENT (PRINT-READY VERSION)" &&
      isPagePermission("Allow Send to Preflight", "AdvanceSearch", 1352)
    );
  };

  // Helper function to check send to downsample conditions
  const shouldShowSendToDownsample = (rowData: any): boolean => {
    return (
      isPagePermission("Allow Send to Downsample", "AdvanceSearch", 1353) &&
      ((rowData.DocumentStatus === "2" &&
        rowData.Rendition_Intern?.toUpperCase() ===
          "CURRENT (PRINT-READY VERSION)") ||
        rowData.Rendition_Intern.toUpperCase() === "CURRENT")
    );
  };

  // Helper function to check send to edelivery conditions
  const shouldShowSendToEdelivery = (rowData: any): boolean => {
    return (
      isPagePermission("Allow Send to Edelivery", "AdvanceSearch", 1354) &&
      rowData.Rendition_Intern?.toUpperCase() === "CURRENT"
    );
  };

  // Helper function to render QueueType 2 menu items
  const renderQueueType2MenuItems = (
    params: any,
    rowData: any,
    handleClose: (actionType: number, rowData: any) => void
  ) => {
    return [
      shouldShowReprocessToSource(params) && (
        <MenuItem
          key={`reprocess-to-source-${rowData.DocumentStreamID}`}
          className="context-menu-item"
          onClick={() => handleClose(1, rowData)}
        >
          Reprocess to Source
        </MenuItem>
      ),
      shouldShowSendToPreflight(rowData) && (
        <MenuItem
          key={`send-to-preflight-${rowData.DocumentStreamID}`}
          className="context-menu-item"
          onClick={() => handleClose(2, rowData)}
        >
          Send to Preflight
        </MenuItem>
      ),
      shouldShowSendToDownsample(rowData) && (
        <MenuItem
          key={`send-to-downsample-${rowData.DocumentStreamID}`}
          className="context-menu-item"
          onClick={() => handleClose(3, rowData)}
        >
          Send to Downsample
        </MenuItem>
      ),
      shouldShowSendToEdelivery(rowData) && (
        <MenuItem
          key={`send-to-edelivery-${rowData.DocumentStreamID}`}
          className="context-menu-item"
          onClick={() => handleClose(4, rowData)}
        >
          Send to E-delivery
        </MenuItem>
      ),
    ];
  };

  // Helper function to render QueueType 1 menu items
  const renderQueueType1MenuItems = (
    rowData: any,
    handleClose: (actionType: number, rowData: any) => void
  ) => {
    const excludedUploadStatuses = getExcludedUploadStatuses();
    const excludedRejectStatuses = getExcludedRejectStatuses();
    const documentStatus = Number(rowData.DocumentStatus);

    return [
      isPagePermission("Allow Upload", "AdvanceSearch", 1356) &&
        !isStatusExcluded(documentStatus, excludedUploadStatuses) && (
          <MenuItem
            key={`upload-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(5, rowData)}
          >
            Upload
          </MenuItem>
        ),
      isPagePermission("Allow Add Notes", "AdvanceSearch", 1359) &&
        rowData.DocumentStatus !== "20" && (
          <MenuItem
            key={`add-notes-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(6, rowData)}
          >
            Add Notes
          </MenuItem>
        ),
      isPagePermission("Allow Move To Preflight", "AdvanceSearch", 1355) &&
        rowData.DocumentStatus === "2" && (
          <MenuItem
            key={`move-to-preflight-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(7, rowData)}
          >
            Move to Preflight
          </MenuItem>
        ),
      isPagePermission(
        "Allow Reprocess - To Preflight",
        "AdvanceSearch",
        1427
      ) &&
        rowData.DocumentStatus === "6" && (
          <MenuItem
            key={`reprocess-to-preflight-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(8, rowData)}
          >
            Reprocess to Preflight
          </MenuItem>
        ),
      checkPermission("Allow Menu TriggerProofFlow") &&
        (rowData.DocumentStatus === "2" ||
          rowData.DocumentStatus === "11" ||
          rowData.DocumentStatus === "18") && (
          <MenuItem
            key={`trigger-proof-wf-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(9, rowData)}
          >
            Trigger Proof WF
          </MenuItem>
        ),
      isPagePermission("Allow Menu TriggerProdFlow", "AdvanceSearch", 1427) &&
        (rowData.DocumentStatus === "11" ||
          rowData.DocumentStatus === "18") && (
          <MenuItem
            key={`trigger-prod-wf-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(10, rowData)}
          >
            Trigger Prod WF
          </MenuItem>
        ),
      isPagePermission("Allow Move To Final Folder", "AdvanceSearch", 1425) &&
        rowData.DocumentStatus === "11" && (
          <MenuItem
            key={`to-final-folder-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(11, rowData)}
          >
            To Final Folder
          </MenuItem>
        ),
      isPagePermission(
        "Allow Move To Final Folder Vis",
        "AdvanceSearch",
        1426
      ) &&
        rowData.DocumentStatus === "18" && (
          <MenuItem
            key={`to-final-folder-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(12, rowData)}
          >
            To Final Folder
          </MenuItem>
        ),
      isPagePermission("Allow Rename", "AdvanceSearch", 6) &&
        !isStatusExcluded(documentStatus, excludedUploadStatuses) && (
          <MenuItem
            key={`rename-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(14, rowData)}
          >
            Rename
          </MenuItem>
        ),
      isPagePermission("Allow Reject", "AdvanceSearch", 1358) &&
        !isStatusExcluded(documentStatus, excludedRejectStatuses) && (
          <MenuItem
            key={`reject-${rowData.DocumentStreamID}`}
            className="context-menu-item"
            onClick={() => handleClose(15, rowData)}
          >
            Reject
          </MenuItem>
        ),
    ];
  };

  // Refactored ActionCellRenderer
  const ActionCellRenderer = (params: any) => {
    const { QueueType } = params.context;
    const rowData = params.data;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: any) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (actionType: number, rowData: any) => {
      const handler = getActionHandler(actionType);
      if (handler) {
        handler(rowData);
      }
      setAnchorEl(null);
    };

    if (params.data === undefined) {
      return "";
    }

    return (
      <div>
        {renderActionButtons(rowData)}

        <Tooltip title="Please click to view the actions">
          <MoreVertIcon
            className="icon-button"
            data-testid={`primary-action`}
            onClick={handleClick}
            style={{
              padding: "0.2vh",
              cursor: "pointer",
            }}
          />
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          keepMounted
        >
          {isPagePermission("Allow Delete", "AdvanceSearch", 10) && (
            <MenuItem
              className="context-menu-item"
              onClick={() => handleClose(0, rowData)}
              key={`delete-${rowData.DocumentStreamID}`}
              data-testid={`delete-action`}
            >
              Delete
            </MenuItem>
          )}

          {QueueType === 2 &&
            renderQueueType2MenuItems(params, rowData, handleClose)}

          {QueueType === 1 && renderQueueType1MenuItems(rowData, handleClose)}
        </Menu>
      </div>
    );
  };

  const checkPermission = (controlid: string): boolean => {
    if (loggedUserData?.pageControlPermission != null) {
      const permissionData = loggedUserData?.pageControlPermission;
      const permissions = JSON.parse(permissionData);
      const result = permissions.find(
        (permission: { PermissionName: string }) =>
          permission.PermissionName === controlid
      );
      return !!result;
    }
    return false;
  };

  const handleSearchChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newInputGroups = [...inputGroups];
    newInputGroups[index].inputValue = event.target.value;
    setInputGroups(newInputGroups);
    setTxtSearch(event.target.value);
  };

  const handleDateChange = (index: number, date: Date | null) => {
    const newInputGroups = [...inputGroups];
    newInputGroups[index].dateValue = date;
    setInputGroups(newInputGroups);
  };

  const handleValueDateChange = (index: number, date: Date | null) => {
    const newInputGroups = [...inputGroups];
    newInputGroups[index].inputValue2 = date;
    setInputGroups(newInputGroups);
  };

  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: appSettings.timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const formatDate = (date: any) => {
    if (!date) return null;
    const parts = formatter.formatToParts(date).reduce((acc: any, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});
    return `${parts.month}/${parts.day}/${parts.year}`;
  };

  const formatterDateTime = new Intl.DateTimeFormat("en-GB", {
    timeZone: appSettings.timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

  const formatDateTime = (date: any) => {
    if (!date) return null;
    const parts = formatterDateTime
      .formatToParts(date)
      .reduce((acc: any, part) => {
        acc[part.type] = part.value;
        return acc;
      }, {});
    return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
  };

  //History - Action buttons events
  const viewHistory = (rowData: any) => {
    setAssetHistoryData(rowData);
    setAssetHistoryOpen(true);
  };

  // Close AssetHistory
  const closeAssetHistory = () => {
    setAssetHistoryOpen(false);
    setAssetHistoryData(null);
  };

  const handleQueryChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setTxtQueryName(event.target.value);
  };

  const errorValidate = () => {
    const newErrors = inputGroups.map((inputGroup) => {
      return {
        selectedField: !inputGroup.selectedField,
        selectedOperator: !inputGroup.selectedOperator,
        inputValue: !inputGroup.isDateField
          ? !inputGroup.inputValue
          : !inputGroup.dateValue,
        inputValue2: inputGroup.isBetweenOperator
          ? !inputGroup.inputValue2
          : false,
        selectedLogicalOperator: !inputGroup.selectedLogicalOperator,
      };
    });
    selectedInputGroupsRef.current.push([...inputGroups]);
    setErrors(newErrors);
    newErrors[0].selectedLogicalOperator = false;
    const hasErrors = newErrors.some(
      (error) =>
        error.selectedField ||
        error.selectedOperator ||
        error.inputValue ||
        error.inputValue2 ||
        error.selectedLogicalOperator
    );

    if (hasErrors) {
      return true;
    }
    return false;
  };

  const handleSearchSubmit = useCallback(
    async (e?: React.FormEvent) => {
      if (e) {
        e.preventDefault();
      }

      if (errorValidate()) {
        return;
      }

      setRowData([]);
      const searchCriterias = inputGroups.map((inputGroup) => {
        const fielditem = {
          metaDataFieldId: Number(inputGroup.selectedField),
          field: inputGroup.selectedField,
          customField: inputGroup.selectedFieldText,
          categoryName: inputGroup.selectedCategory,
          fieldMappingId: Number(inputGroup.selectedField),
          $$hashKey: "",
        };
        let formattedValue1;
        if (!inputGroup.isDateField) {
          formattedValue1 = inputGroup.inputValue;
        } else if (inputGroup.isDateTimeField) {
          formattedValue1 = formatDateTime(inputGroup.dateValue);
        } else {
          formattedValue1 = formatDate(inputGroup.dateValue);
        }

        let formattedValue2 = null;
        if (inputGroup.isBetweenOperator) {
          formattedValue2 = inputGroup.isDateTimeField
            ? formatDateTime(inputGroup.inputValue2)
            : formatDate(inputGroup.inputValue2);
        }

        return {
          logicalOperator: inputGroup.selectedLogicalOperator,
          fielditem: fielditem,
          operator: inputGroup.selectedOperator,
          value1: formattedValue1,
          value2: formattedValue2,
          field: Number(inputGroup.selectedField),
          fieldName: inputGroup.selectedFieldText,
        };
      });

      const payload = {
        currentPage: 0, // Adjust as needed
        noOfRecords: 0, // Adjust as needed
        accountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
        userId: Number(LocalStorageUtil.getItem("userId")),
        isSuperAdmin: Number(LocalStorageUtil.getItem("isSuperAdmin")),
        folderRights: "False",
        contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
        queueType: QueueType,
        isPdfSplitEnabled: "False",
        offSet: appSettings.timezone,
        searchCriterias: searchCriterias,
        isexporttpExcel: true,
      };
      fetchData(payload);

      setOnSearchClick(true);

      if (gridApi) {
        gridApi.onFilterChanged();
      }
    },
    [txtSearch, gridApi, inputGroups, QueueType]
  );

  const getLoogedUserData = async () => {
    try {
      const userData = LocalStorageUtil.getItem("authorizationData");
      if (userData) {
        setLoggedUserData(JSON.parse(userData));
        set_IsAccountDAOEnabled(loggedUserData?.isAccountDAOEnabled === "True");
        set_IsAccountDSAEnabled(loggedUserData?.isAccountDSAEnabled === "True");
        set_IsAccountEdeliveryEnabled(
          loggedUserData?.isAccountEdeliveryEnabled === "True"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetGridData = () => {
    const newinputGroups = [
      {
        selectedField: "",
        selectedFieldText: "",
        selectedOperator: "",
        inputValue: "",
        selectedCategory: "",
        selectedLogicalOperator: "",
        isDateField: false,
        dateValue: "",
        isDateTimeField: false,
        isBetweenOperator: false,
        inputValue2: "",
      },
    ];
    const searchCriterias = newinputGroups.map((inputGroup) => {
      const fielditem = {
        metaDataFieldId: Number(inputGroup.selectedField),
        field: inputGroup.selectedField,
        customField: inputGroup.selectedFieldText,
        categoryName: inputGroup.selectedCategory,
        fieldMappingId: Number(inputGroup.selectedField),
        $$hashKey: "",
      };

      let formattedValue1;
      if (!inputGroup.isDateField) {
        formattedValue1 = inputGroup.inputValue;
      } else if (inputGroup.isDateTimeField) {
        formattedValue1 = formatDateTime(inputGroup.dateValue);
      } else {
        formattedValue1 = formatDate(inputGroup.dateValue);
      }

      let formattedValue2 = null;
      if (inputGroup.isBetweenOperator) {
        formattedValue2 = inputGroup.isDateTimeField
          ? formatDateTime(inputGroup.inputValue2)
          : formatDate(inputGroup.inputValue2);
      }

      return {
        logicalOperator: inputGroup.selectedLogicalOperator,
        fielditem: fielditem,
        operator: inputGroup.selectedOperator,
        value1: formattedValue1,
        value2: formattedValue2,
        field: Number(inputGroup.selectedField),
        fieldName: inputGroup.selectedField,
      };
    });

    const payload = {
      currentPage: 1, // Adjust as needed
      noOfRecords: 0, // Adjust as needed
      accountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
      userId: Number(LocalStorageUtil.getItem("userId")),
      isSuperAdmin: Number(LocalStorageUtil.getItem("isSuperAdmin")),
      folderRights: "False",
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
      queueType: QueueType,
      isPdfSplitEnabled: "False",
      offSet: appSettings.timezone,
      searchCriterias: searchCriterias,
      isexporttpExcel: true,
    };

    fetchData(payload);
  };

  //Rename the columns
  const renameColumns = (val: any) => {
    if (val !== undefined) {
      if (val.toLowerCase() === "ngfamily_id") {
        return "Family_Id";
      } else if (val.toLowerCase() === "project_id") {
        return "Document ID";
      } else if (val.toLowerCase() === "statement_date") {
        return "Date";
      } else if (val.toLowerCase() === "sub_dob") {
        return "DateOfBirth";
      } else if (val.toLowerCase() === "sub_name") {
        return "Name";
      } else if (val.toLowerCase() === "projectdocumentid") {
        return "Document ID";
      } else if (val.toLowerCase() === "dao flag") {
        return "DAO Flag";
      } else if (val.toLowerCase() === "level 1") {
        return "Rendition";
      } else if (val.toLowerCase() === "lastmodifieddate") {
        return "Last Modified Date";
      } else {
        return val.replace(/&amp;/, "&");
      }
    }
  };

  const thumbnailCellRenderer = (params: any) => {
    if (params.data === undefined) {
      return "";
    } else {
      const rowData = params.data;
      if (!rowData.Thumbnail) {
        return <p style={{ marginLeft: "2em" }}>N/A</p>;
      } else {
        return (
          <img
            src={rowData.Thumbnail}
            className="img-responsive"
            alt=""
            width="50px"
            height="50px"
            style={{ margin: "15px" }}
          />
        );
      }
    }
  };

  // Fetch data from API
  const fetchData = async (params: any) => {
    try {
      setShowLoader(true);
      const response = await getAdvanceSearchData(params);
      let { SearchViewModel = [], recordCount = 0 } = response;
      SearchViewModel = SearchViewModel.map((item: any) => ({
        ...item,
        Thumbnail: null,
      }));

      if (!SearchViewModel || SearchViewModel.length === 0) {
        handleNoRecordsFound();
        return;
      }

      setColumnDefs(buildColumnDefs(SearchViewModel[0]));
      await fetchAndSetThumbnails(SearchViewModel);
      setZipDownload(true);
      setDeleteRightShow(true);
      setOnSearchClick(false);
      setGridRecordExist(true);
      setRowData(SearchViewModel);
    } catch (error) {
      showSnackbar("Internal server error", true);
    } finally {
      setShowLoader(false);
    }
  };

  const handleNoRecordsFound = () => {
    showSnackbar("0 Records found");
    setColumnDefs([]);
    setRowData([]);
    setGridRecordExist(false);
  };

  const buildColumnDefs = (firstRow: any) => {
    const columnsToExclude = [
      "RowNum",
      "FileType",
      "DocumentID",
      "DocumentStreamID",
      "DocumentStatus",
      "QueueType",
      "recordCount",
      "latestDocumentDesc",
      "FromPreflightJobNumber",
      "ToPreflightJobNumber",
      "RejectRemarks",
      "RenameRemarks",
      "ProjectDocumentId",
      "ResolutionStatus",
      "ParentDocumentStreamID",
      "AccessPermission",
      "Thumbnail",
      "fileSize",
      "FinalDocID",
      "ToPreflightZipName",
      "Rendition_Intern",
      "PreworkDynamicFilename",
      "ChildAcceptedId",
      "ChildFileUploadedon",
      "ChildFileAcceptedDate",
      "daoflag_Intern",
      "DownloadFileName",
      "SubSystemName",
      "SubSystemConfigurationId",
      "IsAllowSubSystemReprocess",
      "recordCountTemp",
    ];

    const PIN_RIGHT = "right" as const; //NOSONAR
    const dynamicColumns = Object.keys(firstRow)
      .filter((key) => !columnsToExclude.includes(key))
      .map((key) => {
       if (
          (key.toLowerCase().includes("date") &&
            key.toLowerCase() !== "document date") ||
          key.toLowerCase() === "uploaded on" ||
          key.toLowerCase() === "aws date"
        ) {
          return {
            headerName: renameColumns(
              key.charAt(0).toUpperCase() + key.slice(1),
            ),
            field: key,
            sortable: true,
            filter: true,
            enableRowGroup: true,
            valueFormatter: (params: any) => {
              return FormatDate(params.value);
            },
          };
        } else {
          return {
            headerName: renameColumns(
              key.charAt(0).toUpperCase() + key.slice(1),
            ),
            field: key,
            sortable: true,
            filter: true,
            enableRowGroup: true,
          };
        }
      });

    return [
      {
        width: 10,
        sortable: false,
        filter: false,
        hide: false,
        colId: "colCheckbox",
        enableRowGroup: false,
        resizable: false,
      },
      {
        headerName: "#",
        width: 70,
        colId: "colRowNum",
        sortable: false,
        filter: false,
        resizable: false,
        enableRowGroup: false,
        valueGetter: (params: any) =>
          params.node ? (params.node.rowIndex ?? 0) + 1 : 0,
      },
      {
        headerName: "Thumbnail",
        field: "Thumbnail",
        cellRenderer: thumbnailCellRenderer,
        width: 150,
        autoHeight: true,
        enableRowGroup: false,
        resizable: false,
      },
      ...dynamicColumns,
      {
        field: "Actions",
        headerName: "Actions",
        sortable: false,
        enableRowGroup: false,
        pinned: PIN_RIGHT,
        lockPinned: true,
        suppressSizeToFit: false,
        width: 160,
        minWidth: 160,
        cellClass: "actions-button-cell",
        cellRenderer: ActionCellRenderer,
        filter: false,
        resizable: true,
        colId: "colAction",
      },
    ];
  };

  const fetchAndSetThumbnails = async (SearchViewModel: any[]) => {
    const documentIds = SearchViewModel.map(
      (item: any) => item.DocumentStreamID
    );
    try {
      const advanceDocumentViewObj: AdvanceDocumentViewObj = {
        contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
      };
      const thumbnailPayload: FileDownloadRequestModel = {
        AdvanceDocumentViewObj: advanceDocumentViewObj,
        fileObj: documentIds,
      };
      const thumbnailData = await getFileDownload(thumbnailPayload);
      const { objSearch = [] } = thumbnailData;

      if (objSearch?.searchViewStaticModel) {
        setThumbnailsOnRows(SearchViewModel, objSearch.searchViewStaticModel);
      }

      showSnackbar(SearchViewModel.length + " Records found");
    } catch {
      // Ignore thumbnail errors
    }
  };

  const setThumbnailsOnRows = (rows: any[], thumbnails: any[]) => {
    const thumbMap = new Map<number, string | null>();
    thumbnails.forEach((doc: any) => {
      thumbMap.set(
        doc.documentStreamID,
        doc.thumbnail ? `data:image/jpeg;base64,${doc.thumbnail}` : null
      );
    });
    rows.forEach((row: any) => {
      row.Thumbnail = thumbMap.get(Number(row.DocumentStreamID)) ?? null;
    });
  };
  // ...existing code...

  const handleReset = async () => {
    setDialogOpen(false);
    setQueueType(2);
    if (activeButton !== "Build Query") {
      setShowFilter(false);
    }
    setInputGroups([
      {
        selectedField: "",
        selectedFieldText: "",
        selectedOperator: "",
        inputValue: "",
        selectedCategory: "",
        selectedLogicalOperator: "",
        isDateField: false,
      },
    ]);
    setTxtSearch("");
    setZipDownload(false);
    setDeleteRightShow(false);
    setErrors([]);
    setRowData([]);
    setDeleteRightShow(false);
    setZipDownload(false);
    resetGridData();
    setSelectedQueryValue("");
  };

  const clearSelectedRows = () => {
    gridRef.current!.api.deselectAll();
  };
  function buildArfDocumentsUtil(rows: any[]): ARFDocument[] {
    return rows.map((row) => ({
      ProjectDocumentIds: row["Document ID"],
      ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
      AccountId: Number(LocalStorageUtil.getItem("accountId")),
      DocumentStreamId: row["DocumentStreamID"],
      UserId: Number(LocalStorageUtil.getItem("userId")),
    }));
  }

  const deleteSelectetdDocuments = async () => {
    if (!gridRef.current) return;
    let selectedRows = gridRef.current.api.getSelectedRows();
    if (selectedRows.length === 0) {
      showSnackbar("Please select one or more documents to delete.", true);
      return;
    }

    // Normalize selectedRows to array
    let rowsArray: any[];
    if (Array.isArray(selectedRows)) {
      rowsArray = selectedRows;
    } else if (selectedRows) {
      rowsArray = [selectedRows];
    } else {
      rowsArray = [];
    }

    if (rowsArray.length === 0) {
      console.log("No document selected to delete");
      return;
    }

    const actionCode =
      (rowsArray[0] as Record<string, any>)["ACTION CODE"]?.toLowerCase?.() ??
      (selectedRows as Record<string, any>)["ACTION CODE"]?.toLowerCase?.();

    // If actionCode is not 'arf', proceed with ARF logic
    if (actionCode !== "arf") {
      const arfDocuments = buildArfDocumentsUtil(rowsArray);
      if (arfDocuments.length > 0) {
        const arfDocumentResponse = await GetARFDocuments(arfDocuments);
        setDeleteDocumentData(arfDocuments);
        setdeleteConfirmationDialogOpen(true);
        setIsArfMessage(arfDocumentResponse === true);
      }
      return;
    }

    // If actionCode is 'arf', handle single/multiple selection
    const arfDocuments = buildArfDocumentsUtil(rowsArray);
    if (arfDocuments.length > 0) {
      setDeleteDocumentData(arfDocuments);
      setdeleteConfirmationDialogOpen(true);
      setIsArfMessage(false);
    }
  };

  const downloadSelectedFiles = () => {
    if (!gridRef.current) return;

    const selectedRows = gridRef.current.api.getSelectedRows();

    if (selectedRows.length === 0) {
      showSnackbar("Please select the files to Zip and Download", true);
      return;
    }

    if (selectedRows.length === 1) {
      showSnackbar(
        "Please select more than one file to Zip and Download",
        true
      );
      return;
    }

    showSnackbar("Download started ...");

    const documentStreamID: number[] = selectedRows.map(
      (item: any) => item.DocumentStreamID
    );

    if (documentStreamID.length <= 1) return;

    if (hasDuplicateFileNames(selectedRows)) {
      setDialogProps({
        dialogTitle: "Notification",
        contentText:
          "Please note that your Selection Criteria contains duplicate files.Downloaded Duplicate files will be renamed.",
        confirmText: "OK",
        closeText: "Cancel",
        onConfirm: handleDownloadMultipleFiles,
      });
      setDialogOpen(true);
    } else {
      handleDownloadMultipleFiles();
    }
  };

  const hasDuplicateFileNames = (rows: any[]): boolean => {
    const fileNameMap: Record<string, number> = {};
    for (const item of rows) {
      const name = item.DownloadFileName?.toLowerCase();
      if (fileNameMap[name]) {
        return true;
      }
      fileNameMap[name] = 1;
    }
    return false;
  };

  const handleDownloadMultipleFiles = async () => {
    try {
      if (gridRef.current) {
        const selectedRows = gridRef.current.api.getSelectedRows();
        let multiFileDownload = null;
        if (selectedRows.length > 1) {
          let documentStreamID: number[] = [];

          selectedRows.forEach((item: any) => {
            documentStreamID.push(item.DocumentStreamID);
          });

          if (documentStreamID.length > 1) {
            multiFileDownload = {
              Filename: documentStreamID.toString(),
              contextName: LocalStorageUtil.getItem("contextName")?.toString(),
            };
          }
        }

        setShowLoader(true);
        const response = await multipleDownloadFile(multiFileDownload);

        if (response.status === 200) {
          const data = response.data;
          const contentType = response.headers["content-type"];
          const fileName = "documents.zip";

          const linkElement = document.createElement("a");

          const blob = new Blob([data], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          linkElement.href = url;
          linkElement.setAttribute("download", fileName);

          const clickEvent = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: false,
          });
          linkElement.dispatchEvent(clickEvent);
        }

        if (response) {
          showSnackbar("Documents downloaded successfully");
          clearSelectedRows();
        } else {
          showSnackbar("Unable to download file !", true);
        }
        setDialogOpen(false);
      }
    } catch (error) {
      showSnackbar("Something went wrong ! Please try again.", true);
    } finally {
      setDialogOpen(false);
      setShowLoader(false);
    }
  };

  const fileDownload = async (params: any) => {
    const objDownloadFile = {
      documentStreamID: params.DocumentStreamID,
      contextName: LocalStorageUtil.getItem("contextName")?.toString(),
    };

    try {
      setShowLoader(true);
      const response = await downloadFile(objDownloadFile);
      if (response.status === 200) {
        const data = response.data;
        const contentType = response.headers["content-type"];

        const linkElement = document.createElement("a");

        const blob = new Blob([data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        linkElement.href = url;
        linkElement.setAttribute(
          "download",
          params.ProjectDocumentId + params.FileType
        );

        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        linkElement.dispatchEvent(clickEvent);
      }

      if (response) {
        showSnackbar("Documents downloaded successfully");
      } else {
        showSnackbar("Unable to download file !", true);
      }

      setDialogOpen(false);
    } catch (error) {
      showSnackbar("Something went wrong !!!", true);
    } finally {
      setDialogOpen(false);
      setShowLoader(false);
    }
  };

  const viewDocument = (rowData: any) => {
    const id = rowData.DocumentStreamID;
    const encodedId = btoa(id);
    const fileName = rowData.DownloadFileName.replace(/\.[^/.]+$/, "");
    const url = !urlConfig.isDeployed
      ? `/documentviewer/${encodedId}?FileName=${fileName}`
      : `/docdistrov2/documentviewer/${encodedId}?FileName=${fileName}`;
    popupCenter(url, "Document Viewer", 1100, 550);
  };

  const popupCenter = (url: string, title: string, w: number, h: number) => {
    const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
    const dualScreenTop = window.screenTop ?? window.screenY ?? 0;

    const getWidth = () => {
      if (window.innerWidth) return window.innerWidth;
      if (document.documentElement.clientWidth)
        return document.documentElement.clientWidth;
      return window.screen.width;
    };

    const getHeight = () => {
      if (window.innerHeight) return window.innerHeight;
      if (document.documentElement.clientHeight)
        return document.documentElement.clientHeight;
      return window.screen.height;
    };
    const width = getWidth();
    const height = getHeight();

    const left = width / 3 - w / 3 + dualScreenLeft;
    const top = height / 3 - h / 3 + dualScreenTop;
    const newWindow = window.open(
      url,
      title,
      `readonly=true, scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`
    );
    if (newWindow) {
      newWindow.focus();
    }
  };

  const infoDocument = (rowData: any) => {
    setSelectedDocument(rowData);
    toggleDrawer(true)();
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  // ...existing code...
  const metadataCompare = async () => {
    if (!gridRef.current) return;

    const selectedRows = gridRef.current.api.getSelectedRows();
    if (selectedRows.length <= 1) {
      showSnackbar("Please select two or more documents to compare", true);
      return;
    }

    const documentStreamID = selectedRows.map((item: any) =>
      Number(item.DocumentStreamID)
    );
    const contextName = (
      LocalStorageUtil.getItem("contextName") ?? ""
    ).toString();

    const payload: CompareMetaDataRequestModel = {
      sortOrder: 0,
      currentPage: 1,
      noOfRecords: 5,
      SearchText: documentStreamID.toString(),
      AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
      QueueType: QueueType,
      businessUnitID: Number(LocalStorageUtil.getItem("businessUnitId")),
      contextName,
    };

    const advanceDocumentViewObj: AdvanceDocumentViewObj = { contextName };
    const thumbnailPayload: FileDownloadRequestModel = {
      AdvanceDocumentViewObj: advanceDocumentViewObj,
      fileObj: documentStreamID,
    };

    setFields([]);
    setthumbnail([]);
    setLoading(true);

    try {
      const response = await getCompareMetaData(payload);
      const { listSearchStaticModel = [] } = response;

      if (listSearchStaticModel.length > 0) {
        setFields(extractFields(listSearchStaticModel));
      }

      await handleThumbnails(listSearchStaticModel, thumbnailPayload);
      setDialogOpenState(true);
    } catch (error) {
      setOnSearchClick(false);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to extract field item from metadata model
  const extractFieldItem = (item: any, fieldName: string): string => {
    const fieldItem = item.metadataviewModel.find(
      (f: any) => f.field === fieldName
    );
    return fieldItem ? fieldItem.value : "";
  };

  // Helper function to map field values from list
  const mapFieldValues = (
    listSearchStaticModel: any[],
    fieldName: string
  ): string => {
    return listSearchStaticModel
      .map((item: any) => extractFieldItem(item, fieldName))
      .join("/, ");
  };

  // Helper function to create field object
  const createFieldObject = (
    field: any,
    listSearchStaticModel: any[]
  ): { key: string; value: string } => {
    const fieldName = field.field;
    const fieldValues = mapFieldValues(listSearchStaticModel, fieldName);
    return { key: fieldName, value: fieldValues };
  };

  // Refactored extractFields function
  const extractFields = (
    listSearchStaticModel: any[]
  ): { key: string; value: string }[] => {
    const firstItem = listSearchStaticModel[0];
    if (!firstItem?.metadataviewModel) return [];

    return firstItem.metadataviewModel.map((field: any) =>
      createFieldObject(field, listSearchStaticModel)
    );
  };

  const handleThumbnails = async (
    listSearchStaticModel: any[],
    thumbnailPayload: FileDownloadRequestModel
  ) => {
    try {
      const thumbnailData = await getFileDownload(thumbnailPayload);
      const { objSearch = [] } = thumbnailData;
      if (!objSearch?.searchViewStaticModel) return;

      // Only one row for thumbnails, so just map once
      const fieldValues = listSearchStaticModel
        .map((item: any) => (item.thumbnail ? item.thumbnail : ""))
        .join(", ");
      setthumbnail([{ key: "Thumbnail", value: fieldValues }]);
    } catch {
      // Ignore thumbnail errors
    }
  };

  const handlePopupClose = () => {
    setDialogOpenState(false);
  };

  const handleSaveQueryPopupClose = () => {
    setIsSaveQueryOpen(false);
  };

  const saveQuerySubmit = async () => {
    if (txtQueryName === "") {
      setValidateSaveQuery(true);
      return;
    }

    const searchCriterias = inputGroups.map((inputGroup: any) => {
      const fielditem = {
        metaDataFieldId: Number(inputGroup.selectedField),
        field: inputGroup.selectedFieldText,
        customField: inputGroup.selectedFieldText,
        categoryName: inputGroup.selectedCategory, // Add logic to get category name if needed
        fieldMappingId: Number(inputGroup.selectedField),
        $$hashKey: "",
      };

      let formattedValue1;
      if (!inputGroup.isDateField) {
        formattedValue1 = inputGroup.inputValue;
      } else if (inputGroup.isDateTimeField) {
        formattedValue1 = formatDateTime(inputGroup.dateValue);
      } else {
        formattedValue1 = formatDate(inputGroup.dateValue);
      }

      let formattedValue2 = null;
      if (inputGroup.isBetweenOperator) {
        formattedValue2 = inputGroup.isDateTimeField
          ? formatDateTime(inputGroup.inputValue2)
          : formatDate(inputGroup.inputValue2);
      }

      return {
        logicalOperator: inputGroup.selectedLogicalOperator, // Add logic to get logical operator if needed
        fielditem: fielditem,
        operator: inputGroup.selectedOperator,
        value1: formattedValue1,
        value2: formattedValue2,
        field: Number(inputGroup.selectedField),
        fieldName: inputGroup.selectedFieldText,
      };
    });

    const payload: SaveQueryModel = {
      searchCriterias: searchCriterias,
      isPublic: isPublic,
      searchQueryName: txtQueryName,
      active: true,
      accountId: Number(LocalStorageUtil.getItem("accountId")),
      createdBy: Number(LocalStorageUtil.getItem("userId")),
      moduleType: 1,
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
    };

    const response = await SaveAdvanceSearchQuer(payload);
    if (response === 1) {
      showSnackbar("Query name already exists", true);
    } else {
      handleReset();
      handleSaveQueryTabClick(2, "Save Query");
      showSnackbar("Query has been saved successfully");
      setIsSaveQueryOpen(false);
    }
  };

  const handleBuildQueryTabClick = (index: number, value: string) => {
    setShowFilter(true);
    setSelectQuery(false);
    setActiveButton(value);
    setInputGroups([
      {
        selectedField: "",
        selectedFieldText: "",
        selectedOperator: "",
        inputValue: "",
        selectedCategory: "",
        selectedLogicalOperator: "",
        isDateField: false,
        dateValue: "",
        isDateTimeField: false,
        isBetweenOperator: false,
        inputValue2: "",
      },
    ]);
    setErrors([]);
    setRowData([]);
    setDeleteRightShow(false);
    setZipDownload(false);
    resetGridData();
    setSelectedQueryValue("");
  };

  const handleSaveQueryTabClick = async (index: number, value: string) => {
    setShowFilter(false);
    const param: QueryModel = {
      accountId: Number(LocalStorageUtil.getItem("accountId")),
      createdBy: Number(LocalStorageUtil.getItem("userId")),
      moduleType: 1,
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
    };

    const response = await GetSavedQuery(param);
    setSaveQuery(response);
    setSelectQuery(true);
    setActiveButton(value);
    resetGridData();
    setDeleteRightShow(false);
    setZipDownload(false);
    setSelectedQueryValue("");
  };

  const handleSaveQueryChange = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    try {
      setLoading(true);
      setShowFilter(true);
      setSelectedQueryValue(event.target.value);
      setSelectedQueryText(
        event.target.options[event.target.selectedIndex].text
      );

      const param: QueryModel = {
        accountId: Number(LocalStorageUtil.getItem("accountId")),
        contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
        searchQueryID: Number(event.target.value),
      };

      const response = await GetSavedQueryDetails(param);
      const { listSearchCriteriaDetailsModel = [] } = response;

      const newInputGroupData: {
        selectedField: string;
        selectedFieldText: string;
        selectedOperator: string;
        inputValue: string;
        selectedCategory: string | null;
        selectedLogicalOperator: string;
        searchCriteriaID: number | null;
        isDateTimeField: boolean;
        isDateField: boolean;
        dateValue: Date | null;
        inputValue2: Date | null;
        isBetweenOperator: boolean;
      }[] = [];

      listSearchCriteriaDetailsModel.forEach((criteria: any) => {
        setUpdateQueryCreatedBy(criteria.createdBy);
        newInputGroupData.push({
          selectedField: criteria.fieldId,
          selectedFieldText: criteria.metadataFieldName,
          selectedOperator: criteria.operator,
          inputValue: criteria.value1,
          selectedCategory: criteria.metadataFieldName,
          selectedLogicalOperator: criteria.logicalOperator,
          searchCriteriaID: criteria.searchCriteriaID,
          isDateTimeField: criteria.metadataFieldName.includes("Time"),
          isDateField: criteria.metadataFieldName.includes("Date"),
          dateValue: new Date(criteria.value1),
          inputValue2: new Date(criteria.value2),
          isBetweenOperator: criteria.operator === "Between",
        });
      });

      setInputGroups(newInputGroupData);
      selectedInputGroupsRef.current = [newInputGroupData];
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setDialogProps({
      dialogTitle: "Advanced Search",
      contentText: "Are you sure you want to cancel the search?",
      confirmText: "Yes",
      closeText: "No",
      onConfirm: handleReset,
    });
    setDialogOpen(true);
  };

  const handleUpdateQuerySubmit = () => {
    setDialogProps({
      dialogTitle: "Update",
      contentText: "Are you sure you want to Update?",
      confirmText: "Yes",
      closeText: "No",
      onConfirm: AdvanceSearchUpdateQuery,
    });
    setDialogOpen(true);
  };

  const AdvanceSearchUpdateQuery = async () => {
    const searchCriterias = inputGroups.map((inputGroup: any) => {
      const fielditem = {
        metaDataFieldId: Number(inputGroup.selectedField),
        field: inputGroup.selectedFieldText,
        customField: inputGroup.selectedFieldText,
        categoryName: inputGroup.selectedCategory, // Add logic to get category name if needed
        fieldMappingId: Number(inputGroup.selectedField),
        $$hashKey: "",
      };

      let formattedValue1;
      if (!inputGroup.isDateField) {
        formattedValue1 = inputGroup.inputValue;
      } else if (inputGroup.isDateTimeField) {
        formattedValue1 = formatDateTime(inputGroup.dateValue);
      } else {
        formattedValue1 = formatDate(inputGroup.dateValue);
      }

      let formattedValue2 = null;
      if (inputGroup.isBetweenOperator) {
        formattedValue2 = inputGroup.isDateTimeField
          ? formatDateTime(inputGroup.inputValue2)
          : formatDate(inputGroup.inputValue2);
      }

      return {
        searchQueryID: Number(selectedQueryValue),
        searchCriteriaID: Number(inputGroup.searchCriteriaID),
        metadataFieldName: inputGroup.selectedFieldText,
        logicalOperator: inputGroup.selectedLogicalOperator, // Add logic to get logical operator if needed
        fielditem: fielditem,
        operator: inputGroup.selectedOperator,
        value1: formattedValue1,
        value2: formattedValue2,
        field: Number(inputGroup.selectedField),
        fieldName: inputGroup.selectedFieldText,
      };
    });

    const searchCriteriaDetailsModel: SearchCriteriaDetailsModel = {
      searchCriterias: searchCriterias,
      isPublic: true,
      accountId: Number(LocalStorageUtil.getItem("accountId")),
      createdBy: updateQueryCreatedBy,
      isActive: true,
      moduleType: 1,
      searchQueryID: Number(selectedQueryValue),
      searchQueryName: selectedQueryText,
    };

    const payload: UpdateQueryModel = {
      searchCriteriaDetailsModel: searchCriteriaDetailsModel,
      contextName: (LocalStorageUtil.getItem("contextName") ?? "").toString(),
    };
    console.log("UpdateQueryModel:", payload);
    setDialogOpen(false);
    showSnackbar("Query updated successfully");
  };

  const handleSearchKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearchSubmit();
    }
  };

  //Close Confirmation Delete Dialog
  const closeConfirmationDialogbox = (deleted: any) => {
    setdeleteConfirmationDialogOpen(false);
    setDeleteDocumentData(null);
    if (deleted) {
      handleSearchSubmit();
    }
  };

  //Close Reprocess SubSystem Dialog
  const closeReprocessSubSystemDialogbox = (isCancelClick: boolean) => {
    setReprocessSubSystemOpen(false);
    setReprocessSubSystemOpenData(null);
    if (isCancelClick) {
      handleSearchSubmit();
    }
  };

  //Close Reprocess FD Dialog
  const closeReprocessFDDialogbox = (isCancelClick: boolean) => {
    setReprocessFDOpen(false);
    setReprocessFDOpenData(null);
    if (isCancelClick) {
      handleSearchSubmit();
    }
  };

  //Close Reprocess E-Delivery Dialog
  const closeReprocessEDeliveryDialogbox = (isCancelClick: boolean) => {
    setReprocessEDeliveryOpen(false);
    setReprocessEDeliveryOpenData(null);
    if (isCancelClick) {
      handleSearchSubmit();
    }
  };

  const handleStatusChange = () => {
    setIsPublic((prevIsPublic: any) => {
      const updatedStatus = !prevIsPublic;
      return updatedStatus;
    });
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.refreshCells({ force: true }); // Force refresh all cells
    }
  }, [QueueType, gridApi]);

  const handleQueueTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setQueueType(Number(event.target.value));
  };

  // Open Upload Files Pop up
  const handelUploadFiles = (rowData: any, value: number) => {
    setUploadFilesOpen(true);
    setUploadFilesData(rowData);
  };

  // Close Upload Files Pop up
  const closeUploadFiles = (isCancelClick: boolean) => {
    setUploadFilesOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Open Add Notes Pop up
  const handleAddNotes = (rowData: any) => {
    setAddNotesOpen(true);
    setAddNotesData(rowData);
  };

  // Close Add Notes Pop up
  const closeAddNotes = (isCancelClick: boolean, tabValue?: number) => {
    setAddNotesOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  //Open Rename Pop up
  const handleRename = (rowData: any) => {
    setRenamePopupOpen(true);
    setRenameData(rowData);
  };

  //Close Rename Pop up
  const closeRenamePopup = (isCancelClick: boolean) => {
    setRenamePopupOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  //Open Reject Pop up
  const handleReject = (rowData: any) => {
    setLoading(true);
    try {
      let advanceSearchViewModel: any[] = [];

      const createRejectObj = (data: any) => ({
        CheckBoxDocumentId: data.DocumentID,
        CheckBoxDocumentStreamId: data.DocumentStreamID,
        AccepectId: data.childAcceptedId,
        DocumentStatus: data.DocumentStatus,
        AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
        UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
        Remarks: "",
        ContextName: LocalStorageUtil.getItem("contextName") ?? "",
        QueueType: QueueType,
      });

      let selectedRows: any[] = [];
      if (gridRef.current) {
        selectedRows = gridRef.current.api.getSelectedRows();
      }

      if (Array.isArray(selectedRows) && selectedRows.length > 0) {
        advanceSearchViewModel = selectedRows.map(createRejectObj);
      } else {
        advanceSearchViewModel.push(createRejectObj(rowData));
      }

      if (advanceSearchViewModel.length > 0) {
        setRejectPopupOpen(true);
        setRejectData(advanceSearchViewModel);
      }
    } catch (error) {
      console.log("Error in handleReject", error);
    } finally {
      setLoading(false);
    }
  };

  //Close Reject Pop up
  const closeRejectPopup = (isCancelClick: boolean, tabValue?: number) => {
    setRejectPopupOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Close Move to Preflight Pop up
  const closeMoveToPreflight = (isCancelClick: boolean) => {
    setMoveToPreflightOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Open Move to Final Folder, Trigger Proof WF, Trigger Prod WF Pop up
  const moveToFinalFolder = async (
    rowData: any,
    value: number,
    status: number
  ) => {
    try {
      setContextMenuType(status);

      // Set popup title based on status
      const statusTitleMap: Record<number, string> = {
        1: "Move to Final",
        2: "Trigger Proof Workflow",
        3: "Trigger Prod Workflow",
      };
      setMoveToFinalPopupTitle(statusTitleMap[status] || "");

      if (value !== 0) return;

      let PreworkDetails: any[] = [];
      const getMoveToFinalObj = (data: any) => ({
        ParentDocumentID: data.DocumentID,
        DocumentStreamId: data.DocumentStreamID,
        AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
        UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
        FinalDocumentId: data.FinalDocID,
        childFileName: data.DownloadFileName,
        ContextName: LocalStorageUtil.getItem("contextName") ?? "",
        individualFilename: data.DownloadFileName,
        toPreflightZipName: data.ToPreflightZipName,
      });

      if (gridRef.current) {
        let selectedRows = gridRef.current.api.getSelectedRows();
        if (selectedRows.length > 0) {
          PreworkDetails = selectedRows.map(getMoveToFinalObj);
        } else {
          PreworkDetails.push(getMoveToFinalObj(rowData));
        }
        if (PreworkDetails.length > 0) {
          setMoveToFinalFolderOpen(true);
          setMoveToFinalFolderData(PreworkDetails);
        }
      }
    } catch (error) {
      console.error("Error in moveToFinalFolder", error);
    }
  };

  // Close Move to Final Folder, Trigger Proof WF, Trigger Prod WF Pop up
  const closeMoveToFinalFolder = (isCancelClick: boolean) => {
    setMoveToFinalFolderOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Close Reprocess Send to Preflight Pop up
  const closeReprocessSendToPreflight = (isCancelClick: boolean) => {
    setReprocessSendToPreflightOpen(false);
    if (!isCancelClick) {
      handleSearchSubmit();
    }
  };

  // Open Move to Preflight Pop up
  const moveToPreflight = (rowData: any, value: number) => {
    try {
      const getPreworkDetail = (element: any) => ({
        ParentDocumentID: element.DocumentID,
        ParentDocumentStreamID: element.DocumentStreamID,
        ChildFileName: element.DownloadFileName,
        AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
        FromPreflightJobNumber: element.FromPreflightJobNumber,
        FinalDocumentId: element.FinalDocID,
        ContextName: LocalStorageUtil.getItem("contextName") ?? "",
        ToPreflightJobNumber: element.ToPreflightJobNumber,
        UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
        individualFilename: element.DownloadFileName,
        toPreflightZipName: element.ToPreflightZipName,
      });

      let objMoveToPreflight: any = {
        PreworkDetails: [],
        InstructionId: undefined,
        ToPreflighJobNo: undefined,
        ReprocessDocumentStatus: undefined,
        IsCheckClient: undefined,
        ContextName: LocalStorageUtil.getItem("contextName") ?? "",
      };

      if (value !== 0 || !gridRef.current) return;

      let selectedRows = gridRef.current.api.getSelectedRows();
      let PreworkDetails: any[] = [];

      const addPreworkDetails = (elements: any[]) => {
        elements.forEach((element: any) => {
          PreworkDetails.push(getPreworkDetail(element));
        });
      };

      if (selectedRows.length > 0) {
        // If any selected row is not DocumentStatus 20, process those
        const notStatus20 = selectedRows.filter(
          (el: any) => el.DocumentStatus !== 20
        );
        if (notStatus20.length > 0) {
          addPreworkDetails(notStatus20);
          // Use the first element for ToPreflighJobNo and ReprocessDocumentStatus
          const first = notStatus20[0];
          objMoveToPreflight = {
            PreworkDetails,
            InstructionId: undefined,
            ToPreflighJobNo: first.ToPreflightJobNumber,
            ReprocessDocumentStatus: first.DocumentStatus,
            ContextName: LocalStorageUtil.getItem("contextName") ?? "",
          };
        } else if (rowData.parentDocumentStatus === 6) {
          // If all selected are DocumentStatus 20 and parentDocumentStatus is 6
          addPreworkDetails(selectedRows);
          const first = selectedRows[0];
          objMoveToPreflight = {
            PreworkDetails,
            InstructionId: undefined,
            ToPreflighJobNo: first.ToPreflightJobNumber,
            ReprocessDocumentStatus: first.DocumentStatus,
            ContextName: LocalStorageUtil.getItem("contextName") ?? "",
          };
        }
        setMoveToPreflightOpen(true);
        setMoveToPreflightData(objMoveToPreflight);
      } else {
        // No selected rows, use rowData
        PreworkDetails.push(getPreworkDetail(rowData));
        objMoveToPreflight = {
          PreworkDetails,
          InstructionId: undefined,
          ToPreflighJobNo: rowData.ToPreflightJobNumber,
          ReprocessDocumentStatus: rowData.DocumentStatus,
          ContextName: LocalStorageUtil.getItem("contextName") ?? "",
        };
        setMoveToPreflightOpen(true);
        setMoveToPreflightData(objMoveToPreflight);
      }
    } catch (error) {
      console.error("Error in moveToPreflight", error);
    }
  };

  //Handle Export to excel
  const handleExport = () => {
    if (gridRef.current) {
      gridRef.current.api.exportDataAsExcel({
        fileName:
          "AdvanceSearchReports_" + moment().format("YYYYMMDD") + ".xlsx",
        sheetName: "AdvanceSearch Report",
        columnKeys: [
          "colRowNum",
          ...columnDefs
            .map((colDef) => colDef.field)
            .filter(
              (field): field is string =>
                field !== "Thumbnail" && field !== undefined
            ),
        ],
        processCellCallback: function (params) {
          return params.value;
        },
      });
    }
  };

  return (
    <div>
      <NavigationBar
        menuTitle="Search"
        screenTitle=""
        title="Advanced Search"
        text="Advanced Search"
      />
      <Row style={{ margin: "1em", marginTop: "1.6em" }}>
        <Col xs={12} md={8} lg={6}>
          <Box>
            <div>
              <div>
                <div style={{ width: "200%" }}>
                  <Box
                    component="form"
                    sx={{ "& .MuiTextField-root": { m: 1, width: "100ch" } }}
                    noValidate
                    autoComplete="off"
                  >
                    <div
                      className="col-sm-8"
                      style={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                        marginTop: "-12px",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        {isPagePermission(
                          "Allow Build Query",
                          "AdvanceSearch",
                          2
                        ) && (
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() =>
                              handleBuildQueryTabClick(1, "Build Query")
                            }
                            style={{
                              backgroundColor:
                                activeButton === "Build Query"
                                  ? "#ddd"
                                  : "#4D7BA7",
                              color:
                                activeButton === "Build Query"
                                  ? "black"
                                  : "#ddd",
                              marginRight: "1em",
                              fontSize: "11px",
                              borderRadius: "4px",
                              border: "1px solid #858c94",
                              height: "25px",
                            }}
                          >
                            Build Query
                          </Button>
                        )}
                        {isPagePermission(
                          "Allow Saved Queries",
                          "AdvanceSearch",
                          3
                        ) && (
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() =>
                              handleSaveQueryTabClick(2, "Save Query")
                            }
                            style={{
                              backgroundColor:
                                activeButton === "Save Query"
                                  ? "#ddd"
                                  : "#4D7BA7",
                              color:
                                activeButton === "Save Query"
                                  ? "black"
                                  : "#ddd",
                              marginRight: "1em",
                              fontSize: "11px",
                              borderRadius: "4px",
                              border: "1px solid #858c94",
                              height: "25px",
                            }}
                          >
                            Use Saved Queries
                          </Button>
                        )}
                      </div>
                      {
                        <>
                          {isPagePermission(
                            "Allow Downstream",
                            "AdvanceSearch",
                            1366
                          ) &&
                            LocalStorageUtil.getItem("contextName") ===
                              "DocDistro_BrightHouseFinancials" && (
                              <Form.Check
                                id="downstream"
                                type="radio"
                                label="Downstream"
                                radioGroup="queueType"
                                style={{
                                  marginRight: "10px",
                                  color: "var(--text-color)",
                                }}
                                checked={QueueType === 2}
                                onChange={handleQueueTypeChange}
                                value="2"
                              />
                            )}
                          {isPagePermission(
                            "Allow Prework",
                            "AdvanceSearch",
                            1367
                          ) &&
                            LocalStorageUtil.getItem("contextName") ===
                              "DocDistro_BrightHouseFinancials" && (
                              <Form.Check
                                data-testid="queue-type-prework"
                                id="prework"
                                type="radio"
                                label="Prework"
                                radioGroup="queueType"
                                style={{
                                  marginRight: "10px",
                                  color: "var(--text-color)",
                                }}
                                checked={QueueType === 1}
                                onChange={handleQueueTypeChange}
                                value="1"
                              />
                            )}
                        </>
                      }
                    </div>
                    <div style={{ alignItems: "center", marginTop: "0.3em" }}>
                      {selectQuery && (
                        <>
                          <div key="selectQuery1" style={{ display: "flex" }}>
                            <InputLabel
                              style={{
                                justifyContent: "center",
                                alignItems: "center",
                                color: "var(--text-color)",
                                display: "flex",
                                marginBottom: "5px !important",
                                fontWeight: 600,
                                fontSize: "11px",
                                marginLeft: "1ch",
                              }}
                            >
                              Select Query
                            </InputLabel>
                          </div>
                          <div
                            key="selectQuery2"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <select
                              id="selectQuery"
                              value={selectedQueryValue}
                              style={{
                                paddingTop: "0px",
                                backgroundColor: "white",
                                display: "inline-block !important",
                                alignItems: "center",
                                width: "36ch",
                                marginLeft: "1ch",
                                height: "25px",
                                fontSize: "11px",
                              }}
                              onChange={(event) => handleSaveQueryChange(event)}
                            >
                              <option aria-label="None" value="">
                                Select
                              </option>
                              {SaveQuery?.map((option) => (
                                <option
                                  key={`savequery-${option.searchQueryID}`}
                                  value={option.searchQueryID}
                                >
                                  {option.searchQueryName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </>
                      )}
                      {showFilter && (
                        <div key="showFilter" style={{ display: "flex" }}>
                          <InputLabel
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                              color: "var(--text-color)",
                              display: "inline-block !important",
                              marginBottom: "5px !important",
                              fontWeight: 600,
                              fontSize: "11px",
                              marginLeft: "7px",
                            }}
                          >
                            AND/OR
                          </InputLabel>
                          <InputLabel
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                              color: "var(--text-color)",
                              display: "inline-block !important",
                              marginBottom: "5px !important",
                              fontWeight: 600,
                              fontSize: "11px",
                              marginLeft: "14ch",
                            }}
                          >
                            Field
                          </InputLabel>
                          <InputLabel
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                              color: "var(--text-color)",
                              display: "inline-block !important",
                              marginBottom: "5px !important",
                              fontWeight: 600,
                              fontSize: "11px",
                              marginLeft: "20ch",
                            }}
                          >
                            Operator
                          </InputLabel>
                          <InputLabel
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                              color: "var(--text-color)",
                              display: "inline-block !important",
                              marginBottom: "5px !important",
                              fontWeight: 600,
                              fontSize: "11px",
                              marginLeft: "11ch",
                            }}
                          >
                            Value
                          </InputLabel>
                        </div>
                      )}
                    </div>
                    {showFilter && (
                      <>
                        {inputGroups.map((inputGroup, index) => (
                          <>
                            <div
                              key={inputGroup.id || index}
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {index !== 0 && (
                                <select
                                  id={`andor_${index}`}
                                  value={inputGroup.selectedLogicalOperator}
                                  name={inputGroup.selectedLogicalOperator}
                                  style={{
                                    paddingTop: "0px",
                                    backgroundColor: "white",
                                    display: "inline-block !important",
                                    alignItems: "center",
                                    width: "18ch",
                                    marginLeft: "1ch",
                                    height: "25px",
                                    fontSize: "11px",
                                  }}
                                  onChange={(event) =>
                                    handleLogicalOperatorChange(index, event)
                                  }
                                >
                                  <option aria-label="None" value="">
                                    Select
                                  </option>
                                  {andOr.map((option) => (
                                    <option
                                      key={`andor-${option.value}`}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              )}
                              <select
                                id={`field_${index}`}
                                value={inputGroup.selectedField}
                                name={inputGroup.selectedField}
                                style={{
                                  paddingTop: "0px",
                                  backgroundColor: "white",
                                  display: "inline-block !important",
                                  alignItems: "center",
                                  width: "23ch",
                                  marginLeft: index !== 0 ? "3ch" : "22ch",
                                  height: "25px",
                                  fontSize: "11px",
                                }}
                                onChange={(event) =>
                                  handleFieldChange(index, event)
                                }
                              >
                                <option aria-label="None" value="">
                                  Select
                                </option>
                                {categories.map((category, i) => (
                                  <optgroup
                                    key={`category-${category.label}`}
                                    label={category.label}
                                  >
                                    {category.options.map((option, j) => (
                                      <option
                                        key={`option-${option.value}`}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </option>
                                    ))}
                                  </optgroup>
                                ))}
                              </select>
                              <select
                                id={`operator_${index}`}
                                value={inputGroup.selectedOperator}
                                name={inputGroup.selectedOperator}
                                style={{
                                  paddingTop: "0px",
                                  backgroundColor: "white",
                                  display: "inline-block !important",
                                  alignItems: "center",
                                  width: "18ch",
                                  marginLeft: "1ch",
                                  height: "25px",
                                  fontSize: "11px",
                                }}
                                onChange={(event) =>
                                  handleOperatorChange(index, event)
                                }
                              >
                                <option aria-label="None" value="">
                                  Select
                                </option>
                                {!inputGroup.isDateField &&
                                  operator.map((option) => (
                                    <option
                                      key={`operator-field-${option.value}`}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                {inputGroup.isDateField &&
                                  dateOperator.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                              </select>
                              <TextField
                                variant="outlined"
                                fullWidth
                                style={{
                                  paddingTop: "0px",
                                  backgroundColor: "white",
                                  display: "none",
                                  alignItems: "center",
                                  width: "40ch",
                                  marginLeft: "15px",
                                  padding: "2px",
                                }}
                                InputProps={{
                                  style: {
                                    height: "24px",
                                    fontSize: "11x",
                                    borderColor: errors[index]?.inputValue
                                      ? "red"
                                      : "initial",
                                  },
                                }}
                                id={`txtSimpleSearch_${index}`}
                                name={inputGroup.inputValue}
                                value={inputGroup.inputValue}
                                onChange={(event) =>
                                  handleSearchChange(index, event)
                                }
                              >
                                <MenuItem
                                  style={{ fontSize: "11px" }}
                                ></MenuItem>
                              </TextField>
                              {!inputGroup.isDateField ? (
                                <input
                                  type="text"
                                  id={`txtSimpleSearch_${index}`}
                                  name={inputGroup.inputValue}
                                  value={inputGroup.inputValue}
                                  style={{
                                    width: "15em",
                                    height: "2.3em",
                                    marginTop: "-.1em",
                                    marginLeft: ".5em",
                                    fontSize: "11px",
                                  }}
                                  onChange={(event) =>
                                    handleSearchChange(index, event)
                                  }
                                  onKeyDown={handleSearchKeyPress}
                                />
                              ) : (
                                <Form.Control
                                  type="date"
                                  placeholder="From Date"
                                  name="fromdate"
                                  max={new Date().toISOString().split("T")[0]}
                                  value={
                                    inputGroup.dateValue
                                      ? inputGroup.dateValue
                                          .toISOString()
                                          .split("T")[0]
                                      : ""
                                  }
                                  onChange={(e) =>
                                    handleDateChange(
                                      index,
                                      new Date(e.target.value)
                                    )
                                  }
                                  style={{
                                    padding: ".3em",
                                    width: "13%",
                                    fontSize: "11px",
                                    borderRadius: "0",
                                    border: "1px solid #ccc",
                                    borderColor: "black",
                                    marginTop: ".2em",
                                    marginLeft: ".5em",
                                  }}
                                />
                              )}
                              {inputGroup.isBetweenOperator && (
                                <Form.Control
                                  type="date"
                                  placeholder="From Date"
                                  name="fromdate"
                                  max={new Date().toISOString().split("T")[0]}
                                  value={
                                    inputGroup.inputValue2
                                      ? inputGroup.inputValue2
                                          .toISOString()
                                          .split("T")[0]
                                      : ""
                                  }
                                  onChange={(e) =>
                                    handleValueDateChange(
                                      index,
                                      new Date(e.target.value)
                                    )
                                  }
                                  style={{
                                    padding: ".3em",
                                    width: "13%",
                                    fontSize: "11px",
                                    borderRadius: "0",
                                    border: "1px solid #ccc",
                                    borderColor: "black",
                                    marginTop: ".2em",
                                    marginLeft: ".5em",
                                  }}
                                />
                              )}
                              {index !== 0 && (
                                <Tooltip title="Please click to delete row">
                                  <DeleteForeverIcon
                                    style={{
                                      backgroundColor:
                                        "var(--button-background-color)",
                                      color: "var(--button-color)",
                                      marginLeft: "1ch",
                                      height: ".7em",
                                      width: ".7em",
                                    }}
                                    onClick={() =>
                                      handleDeleteInputGroup(index)
                                    }
                                  ></DeleteForeverIcon>
                                </Tooltip>
                              )}
                              {index === inputGroups.length - 1 && (
                                <Tooltip title="Please click to add row">
                                  <AddBoxIcon
                                    data-testid="add-input-group"
                                    style={{
                                      backgroundColor:
                                        "var(--button-background-color)",
                                      color: "var(--button-color)",
                                      marginLeft: "1ch",
                                      height: ".7em",
                                      width: ".7em",
                                    }}
                                    onClick={handleAddInputGroup}
                                  ></AddBoxIcon>
                                </Tooltip>
                              )}
                            </div>
                            <div style={{ marginBottom: "15px" }}>
                              {index !== 0 &&
                                errors[index]?.selectedLogicalOperator && (
                                  <Typography
                                    color="error"
                                    variant="body2"
                                    style={{
                                      fontSize: "11px",
                                      marginBottom: "5px",
                                      marginLeft: "1ch",
                                      color: "red",
                                      position: "absolute",
                                    }}
                                  >
                                    Please select
                                  </Typography>
                                )}
                              {errors[index]?.selectedField && (
                                <Typography
                                  color="error"
                                  variant="body2"
                                  style={{
                                    fontSize: "11px",
                                    marginBottom: "5px",
                                    position: "absolute",
                                    marginLeft: "20ch",
                                    color: "red",
                                  }}
                                >
                                  Please select the Field
                                </Typography>
                              )}
                              {errors[index]?.selectedOperator && (
                                <Typography
                                  color="error"
                                  variant="body2"
                                  style={{
                                    fontSize: "11px",
                                    marginBottom: "5px",
                                    position: "absolute",
                                    marginLeft: "49ch",
                                    color: "red",
                                  }}
                                >
                                  Please select the Operator
                                </Typography>
                              )}
                              {errors[index]?.inputValue && (
                                <Typography
                                  color="error"
                                  variant="body2"
                                  style={{
                                    fontSize: "11px",
                                    marginBottom: "5px",
                                    position: "absolute",
                                    marginLeft: "72ch",
                                    color: "red",
                                  }}
                                >
                                  Please enter the Value1
                                </Typography>
                              )}
                              {inputGroup.isBetweenOperator &&
                                errors[index]?.inputValue2 && (
                                  <Typography
                                    color="error"
                                    variant="body2"
                                    style={{
                                      fontSize: "11px",
                                      marginBottom: "5px",
                                      position: "absolute",
                                      marginLeft: "64em",
                                      color: "red",
                                    }}
                                  >
                                    Please enter the Value2
                                  </Typography>
                                )}
                            </div>
                          </>
                        ))}
                        <div
                          style={{
                            display: "flex",
                            gap: "2px",
                            marginTop: "1em",
                            width: "100%",
                          }}
                        >
                          <div className="col-sm-6">
                            <Button
                              variant="outlined"
                              type="button"
                              onClick={handleSearchSubmit}
                              className="button"
                            >
                              Search
                            </Button>
                            {selectQuery && (
                              <Button
                                variant="outlined"
                                type="button"
                                onClick={handleUpdateQuerySubmit}
                                className="button save-button"
                              >
                                Update
                              </Button>
                            )}
                            <Button
                              variant="outlined"
                              type="button"
                              onClick={handleSaveQuerySubmit}
                              className="button save-button"
                            >
                              {selectQuery ? "Save As" : "Save Query"}
                            </Button>
                          </div>
                          <div
                            className="col-sm-6"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            {deleteRightShow &&
                            isPagePermission(
                              "Allow Metadata Compare",
                              "AdvanceSearch",
                              5
                            ) ? (
                              <Button
                                variant="contained"
                                id="delete"
                                size="small"
                                onClick={metadataCompare}
                                className="button metadata-button"
                              >
                                Metadata compare
                              </Button>
                            ) : null}
                            {deleteRightShow &&
                            isPagePermission(
                              "Allow Delete",
                              "AdvanceSearch",
                              10
                            ) ? (
                              <Button
                                variant="contained"
                                id="delete"
                                size="small"
                                onClick={deleteSelectetdDocuments}
                                className="button"
                              >
                                Delete
                              </Button>
                            ) : null}
                            {zipDownload && (
                              <Button
                                id="zipanddownload"
                                variant="contained"
                                size="small"
                                onClick={downloadSelectedFiles}
                                className="button download-zip-button"
                                data-testid="zip-download-button"
                              >
                                Zip and Download
                              </Button>
                            )}
                            <Button
                              type="button"
                              variant="outlined"
                              className="button"
                              onClick={handleCancel}
                              aria-label="delete"
                            >
                              Cancel
                            </Button>
                            {gridRecordExist && (
                              <Tooltip title="Click to export the grid content in excel">
                                <button
                                  type="button"
                                  onClick={handleExport}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    cursor: "pointer",
                                    marginTop: "-.2em",
                                    alignItems: "center",
                                    display: "flex",
                                  }}
                                  aria-label="Export to Excel"
                                >
                                  <img
                                    src={ExcelIcon}
                                    alt="Doc-Distro"
                                    className="excel-icon"
                                    style={{
                                      marginTop: "0.5em",
                                    }}
                                  />
                                </button>
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </Box>
                </div>
              </div>
              <div>
                <div
                  className="ag-theme-quartz-dark"
                  style={{
                    height: `${gridHeight}px`,
                    width: "200%",
                  }}
                >
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={rowData}
                    onGridReady={onGridReady}
                    ref={gridRef}
                    pagination={true}
                    paginationPageSize={defaulPageSize}
                    paginationPageSizeSelector={pageSizeSelector}
                    headerHeight={30}
                    rowHeight={20}
                    domLayout="normal"
                    rowGroupPanelShow="always"
                    pivotPanelShow="always"
                    gridOptions={{
                      rowSelection: {
                        mode: "multiRow",
                        checkboxes: true,
                        headerCheckbox: true,
                        enableClickSelection: false,
                      },
                    }}
                    overlayNoRowsTemplate={
                      '<span class="ag-overlay-loading-center">No rows to show</span>'
                    }
                    loading={!rowData || showLoader}
                    loadingOverlayComponent={CustomLoadingOverlay}
                    context={{ QueueType }}
                  />
                </div>
              </div>

              <ConfirmationDialog
                open={dialogOpen}
                onClose={handleDialogClose}
                onConfirm={dialogProps.onConfirm}
                contentText={dialogProps.contentText}
                closeText={dialogProps.closeText}
                confirmText={dialogProps.confirmText}
                dialogTitle={dialogProps.dialogTitle}
              />

              <div>
                <InfoDrawer
                  isOpen={drawerOpen}
                  onClose={toggleDrawer(false)}
                  title="Document Info"
                  tabLabels={["Information", "Version History"]}
                  selectedDocument={selectedDocument}
                />
              </div>
            </div>
            <div>
              <BootstrapDialog
                onClose={handlePopupClose}
                aria-labelledby="customized-dialog-title"
                open={dialogOpenState}
                PaperProps={{
                  sx: { width: "100%", maxWidth: "100%", height: "900px" },
                }}
              >
                <DialogTitle
                  className={styles.dialogtitle}
                  sx={{
                    m: 0,
                    p: 1,
                    fontWeight: "bold",
                    fontSize: "14px",
                    lineHeight: "1.5",
                    padding: "1em",
                    backgroundColor: "var(--primary-color)",
                    color: "var(--aggrid-text-color)",
                  }}
                  id="customized-dialog-title"
                >
                  Metadata Compare
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={handlePopupClose}
                  sx={(theme) => ({
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                    padding: "0px",
                  })}
                  style={{ color: "var(--aggrid-text-color)" }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                  <div
                    className="col-sm-12 pull-left"
                    style={{ width: "100%", height: "100%" }}
                  >
                    <div
                      className="table-container"
                      style={{
                        width: "100%",
                        height: "100%",
                        overflowX: "auto",
                        overflowY: "auto",
                      }}
                    >
                      <table
                        style={{
                          marginBottom: "0",
                          border: "1px solid #8eb4d8",
                          width: "max-content", // Ensures horizontal scroll if needed
                          minWidth: "100%", // Prevents column overlap
                          color: "#212529",
                          tableLayout: "fixed",
                          borderCollapse: "separate",
                          borderSpacing: "3px", // Adds gap between columns
                        }}
                      >
                        <tbody>
                          {/* Table Header */}
                          <tr>
                            <th
                              style={{
                                minWidth: "15em",
                                maxWidth: "15em",
                                paddingLeft: "1em",
                                position: "sticky",
                                left: "0",
                                background: "#fff",
                                zIndex: "2",
                                fontSize: "12px",
                              }}
                            >
                              Thumbnail
                            </th>
                            {thumbnail.length === 0
                              ? fields[0]?.value.split(",").map((value) => (
                                  <th
                                    key={value.trim()}
                                    style={{
                                      /* ...styles... */
                                      fontSize: "11px",
                                    }}
                                  >
                                    Document {value.trim()}
                                  </th>
                                ))
                              : thumbnail.map((item1, subIndex) =>
                                  item1.value.split(",").map(
                                    (value, valueIndex) =>
                                      subIndex === 0 && (
                                        <th
                                          key={`thumbnail-header-${value.trim()}`}
                                          style={{
                                            /* ...styles... */
                                            fontSize: "11px",
                                          }}
                                        >
                                          Document {valueIndex + 1}
                                        </th>
                                      )
                                  )
                                )}
                          </tr>

                          {/* Table Rows */}
                          {fields.map((item1, subIndex) => (
                            <tr key={`field-row-${item1.key}`}>
                              <th
                                style={{
                                  minWidth: "15em",
                                  maxWidth: "15em",
                                  paddingLeft: "1em",
                                  position: "sticky",
                                  left: "0",
                                  background: "#fff",
                                  zIndex: "2",
                                  fontSize: "12px",
                                }}
                              >
                                <span>{item1.key}</span>
                              </th>
                              {item1.value
                                .split("/,")
                                .map((value, valueIndex) => (
                                  <td
                                    key={`field-value-${item1.key}`}
                                    style={{
                                      background:
                                        subIndex % 2 === 0
                                          ? "#f9f9f9"
                                          : "#8eb4d8",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {value}
                                  </td>
                                ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </DialogContent>
              </BootstrapDialog>
            </div>
            <div>
              <BootstrapDialog
                onClose={handleSaveQueryPopupClose}
                aria-labelledby="customized-dialog-title"
                open={isSaveQueryOpen}
                PaperProps={{ sx: { maxWidth: "1500px", height: "300px" } }}
              >
                <DialogTitle
                  className={styles.dialogtitle}
                  sx={{
                    m: 0,
                    p: 1,
                    fontWeight: "bold",
                    fontSize: "14px",
                    lineHeight: "1.5",
                    padding: "8px",
                    backgroundColor: "var(--primary-color)",
                    color: "var(--aggrid-text-color)",
                  }}
                  id="customized-dialog-title"
                >
                  Save Query
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={handleSaveQueryPopupClose}
                  sx={(theme) => ({
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                    padding: "0px",
                  })}
                  style={{ color: "var(--aggrid-text-color)" }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                  <>
                    <div>
                      <span
                        style={{
                          display: "flex",
                          fontWeight: 600,
                          fontSize: "14px",
                        }}
                      >
                        Query Name
                      </span>
                      <TextField
                        variant="outlined"
                        fullWidth
                        style={{
                          paddingTop: "0px",
                          display: "inline-block !important",
                          alignItems: "center",
                          width: "40ch",
                          marginLeft: "-2px",
                          padding: "2px",
                        }}
                        InputProps={{
                          style: {
                            height: "24px",
                            fontSize: "11x",
                            borderColor: errors[index]?.inputValue
                              ? "red"
                              : "initial",
                            paddingLeft: "0.2em",
                          },
                        }}
                        name="search"
                        id="txtSimpleSearch"
                        value={txtQueryName}
                        onChange={handleQueryChange}
                      >
                        <MenuItem style={{ fontSize: "11px" }}></MenuItem>
                      </TextField>
                      {validateSaveQuery && (
                        <Typography
                          color="error"
                          variant="body2"
                          style={{ marginBottom: "10px" }}
                        >
                          Please enter Query Name
                        </Typography>
                      )}
                    </div>
                    <div style={{ marginLeft: "-10px" }}>
                      <Checkbox
                        checked={isPublic}
                        onChange={handleStatusChange}
                      />{" "}
                      <span
                        style={{
                          marginBottom: "5px !important",
                          fontWeight: 600,
                          fontSize: "14px",
                        }}
                      >
                        Public
                      </span>
                      <span
                        style={{
                          display: "flex",
                          marginLeft: "10px",
                          marginBottom: "5px !important",
                          fontWeight: 600,
                          fontSize: "14px",
                        }}
                      >
                        Public can be seen by other users.
                      </span>
                    </div>
                  </>
                </DialogContent>
                <DialogActions>
                  <Button
                    className={styles.buttonContainerClass}
                    onClick={saveQuerySubmit}
                  >
                    Save
                  </Button>
                  <Button
                    className={styles.buttonContainerClass}
                    onClick={handleSaveQueryPopupClose}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </BootstrapDialog>
            </div>
            {assetHistoryOpen && (
              <AssetHistory
                isOpen={assetHistoryOpen}
                onClose={closeAssetHistory}
                title=""
                selectedData={assetHistoryData}
              />
            )}
            {/* Delete Confirmation dialogbox */}
            {deleteConfirmationDialogOpen && (
              <ConfirmationAlert
                isOpen={deleteConfirmationDialogOpen}
                onClose={(e) => closeConfirmationDialogbox(e)}
                title="Delete Confirmation"
                selectedData={deleteDocumentData}
                isArf={isArfMessage}
                screen="DownstreamSummary"
              />
            )}

            {/* Reprocess SubSystem dialogbox */}
            {reprocessSubSystemOpen && (
              <DownstreamSubSystemReprocessPopup
                isOpen={reprocessSubSystemOpen}
                onClose={closeReprocessSubSystemDialogbox}
                title="Reprocess"
                selectedData={reprocessSubSystemOpenData}
                documentStatusFlag={false}
              />
            )}

            {/* Reprocess Downsample and Preflight  */}
            {reprocessFDOpen && (
              <DownstreamFDReprocesspopup
                isOpen={reprocessFDOpen}
                onClose={closeReprocessFDDialogbox}
                title="Reprocess"
                selectedData={reprocessFDOpenData}
                value={1}
              />
            )}

            {/* Reprocess EDelivery */}
            {reprocessEDeliveryOpen && (
              <DownstreamFDReprocesspopup
                isOpen={reprocessEDeliveryOpen}
                onClose={closeReprocessEDeliveryDialogbox}
                title="Reprocess"
                selectedData={reprocessEDeliveryOpenData}
                value={2}
              />
            )}
            {/* Upload Files Dialog */}
            {uploadFilesOpen && (
              <FileUploads
                isOpen={uploadFilesOpen}
                onClose={closeUploadFiles}
                title="Upload Files"
                selectedData={uploadFilesData}
                screenType="advanceSearch"
              />
            )}

            {/* Add Notes Dialog */}
            {addNotesOpen &&
              isPagePermission("Allow Add Notes", "AdvanceSearch", 1359) && (
                <AddNotes
                  isOpen={addNotesOpen}
                  onClose={closeAddNotes}
                  title="Add Notes"
                  selectedData={addNotesData}
                  screenType="PreworkDetails"
                />
              )}

            {/* Rename popup */}
            {renamePopupOpen && (
              <RenamePopup
                isOpen={renamePopupOpen}
                onClose={closeRenamePopup}
                title="Rename File"
                selectedData={renameData}
              />
            )}

            {/* Reject popup */}
            {rejectPopupOpen && (
              <RejectFile
                isOpen={rejectPopupOpen}
                onClose={closeRejectPopup}
                title="Reject File"
                selectedData={rejectData}
              />
            )}
            {/* Move to Preflight Dialog */}
            {moveToPreflightOpen && (
              <MoveToPreflightPopup
                isOpen={moveToPreflightOpen}
                onClose={closeMoveToPreflight}
                title="Move To Preflight"
                selectedData={moveToPreflightData}
                documentStatus={documentStatusValue}
              />
            )}

            {/* Move to Final Folder Dialog */}
            {moveToFinalFolderOpen && (
              <MoveToFinal
                isOpen={moveToFinalFolderOpen}
                onClose={closeMoveToFinalFolder}
                title={moveToFinalPopupTitle}
                selectedData={moveToFinalFolderData}
                contextMenuType={contextMenuType}
              />
            )}

            {/* Reprocess Send to Preflight Dialog */}
            {reprocessSendToPreflightOpen && (
              <ReprocessSendToPreflight
                isOpen={reprocessSendToPreflightOpen}
                onClose={closeReprocessSendToPreflight}
                title="Reprocess"
                selectedData={reprocessSendToPreflightData}
              />
            )}
          </Box>
        </Col>
      </Row>
    </div>
  );
};

export default AdvancedSearch;
